export enum ThreeDSType {
  ADDING_CARD = 'adding_card',
  VALIDATING_CARD = 'validating_card',
  VALIDATING_PAYMENT = 'validating_payment',
}
